<div class="main-content bg-white">
	<div class="top-bar p-2">
		<div class="row m-0 p-0">
			<h2 class="page-title">Sticker Feed Panel</h2>
			<div class="page-actions">
				<div class="actions d-flex">
					<button mat-stroked-button class="btn-small" color="primary" (click)="addclient()">Add client<mat-icon>person</mat-icon></button>
				</div>
				<div class="overviews">
					<div class="top-total">Open orders <strong>{{total_order_count}}</strong></div>
					<div class="top-total">Total units<strong>{{total_unit_count}}</strong></div>
					<ng-container *ngIf="!all_loaded">
						<svg class="spinner" width="15px" height="15px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
	

	<ng-container>
		<div class="card-backdrop" *ngIf="anyExpanded" (click)="closeExpanded()"></div>

		<div class="panel">
			<div class="card-container">
				<div *ngFor="let c of clients" [ngClass]="{'d-none': c.id === 'new' && !c.focused}">
			
				<div class="vendor-card-placeholder" *ngIf="c.focused">
					<h4 class="placeholder-header">{{c.vendor_label}}</h4>
					<svg class="placeholder-icon" width="32" height="32" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="viewing_icon"></svg>
				</div>

				<mat-card class="vendor-card mat-elevation-z2"
					[ngStyle]="titlePillVars(c)"
					[class.is-focused]="c.focused"
					[class.is-closing]="c.closing"
					[class.is-dimmed]="anyExpanded && !c.focused"
					[class.is-inactive]="c.status == 'red'"
					[class.viewing-orders]="c.viewing == 'orders'">
				<mat-card-header [class.vendor-card-header-expanded]="c.focused" class="vendor-card-header">
					<mat-card-title>
						<div class="row justify-content-between client-label client-label {{c.connection_type ==='api' ? 'api' : 'feed'}}">
							<div class="client-title-group">
							<div class="card-icon-badge">{{ vendorInitial(c) + c.vendor_label.substring(1, c.vendor_label.length) }}</div>
							<h4>
								<p *ngIf="c.focused && c.adding" class="font-weight-lighter">New Client set up &nbsp;</p>
								<!-- <span class="client-title-pill">{{c.vendor_label}}</span> -->
								<!-- <span *ngIf="c.focused">{{type_label}}</span> -->
							</h4>
							<div class="row pl-2 pr-2 ml-2 mr-2 cursor-hover" [ngClass]="{'d-none': !c.focused}">
								<span [ngClass]="{'label_view mat-elevation-z2': type_label === 'analytics'}">
									<span *ngIf="type_label === 'analytics'">{{type_label | uppercase}}</span>
									<svg class="card-icon" width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="analytics_icon" (click)="flipClientCard(c, 'analytics')" title="Connection log"></svg>
								</span>
								<span [ngClass]="{'label_view mat-elevation-z2': type_label === 'orders'}">
									<span *ngIf="type_label === 'orders'">{{type_label | uppercase}}</span>
									<svg class="card-icon" width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="orders_icon" (click)="flipClientCard(c, 'orders')" title="Orders"></svg>
								</span>
								<span [ngClass]="{'label_view mat-elevation-z2': type_label === 'settings'}">
									<span *ngIf="type_label === 'settings'">{{type_label | uppercase}}</span>
									<svg class="card-icon" width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="settings_icon" (click)="flipClientCard(c, 'settings')" title="Settings"></svg>
								</span>
							</div>
							</div>
							<span class="status-container">
								<strong class="status-label" *ngIf="c?.status == 'red' || c?.connection">
									<ng-container *ngIf="!c.connection">missing credentials</ng-container>
									<ng-container *ngIf="c.connection">{{c.connection.message}}</ng-container>
								</strong>

								<span class="status-dot-wrap d-block">
									<span class="connectiontype-pill" *ngIf="c.connection_type === 'api'">API</span>
									<span class="connectiontype-pill" *ngIf="c.connection_type !== 'api'">FILE DROP</span>
									<span class="status-dot" [ngClass]="'status-' + c.status"></span>

									<div class="credentials-popover">
										<ng-container *ngIf="c.connection_type !== 'api'">
											<div class="summary-row">
												<span class="summary-label">User</span>
												<span class="summary-value">{{c.username ? c.username : 'Missing'}}</span>
											</div>
											<div class="summary-row">
												<span class="summary-label">Password</span>
												<i class="material-icons summary-status-icon" [ngClass]="c.password_set ? 'is-set' : 'is-missing'" [title]="c.password_set ? 'Set' : 'Missing'">
													{{ c.password_set ? 'check_circle' : 'cancel' }}
												</i>
											</div>
											<div class="summary-row">
												<span class="summary-label">Host / Path</span>
												<span class="summary-value" [title]="(c.serverhost || 'Missing') + (c.path ? ' — ' + c.path : '')">
													{{c.serverhost ? c.serverhost : 'Missing'}}<span *ngIf="c.path"> — {{c.path}}</span>
												</span>
											</div>
										</ng-container>
										<ng-container *ngIf="c.connection_type === 'api'">
											<div class="summary-row">
												<span class="summary-label">Auth</span>
												<span class="summary-value">{{ c.auth_type === 'static_bearer' ? 'Static Bearer' : 'OAuth2 Client Credentials' }}</span>
											</div>
											<div class="summary-row">
												<span class="summary-label">Credentials</span>
												<i class="material-icons summary-status-icon"
													[ngClass]="(c.auth_type === 'static_bearer' ? c.access_token_set : (c.client_id && c.client_secret_set)) ? 'is-set' : 'is-missing'"
													[title]="(c.auth_type === 'static_bearer' ? c.access_token_set : (c.client_id && c.client_secret_set)) ? 'Set' : 'Missing'">
													{{ (c.auth_type === 'static_bearer' ? c.access_token_set : (c.client_id && c.client_secret_set)) ? 'check_circle' : 'cancel' }}
												</i>
											</div>
											<div class="summary-row" *ngIf="c.auth_type !== 'static_bearer'">
												<span class="summary-label">Client ID</span>
												<span class="summary-value" [title]="c.client_id || 'Not generated'">{{c.client_id ? c.client_id : 'Not generated'}}</span>
											</div>
										</ng-container>
										<div class="summary-row">
											<span class="summary-label">Last Time/Size</span>
											<span class="summary-value font-weight-lighter">
												{{c.lastsent ? c.lastsent : ''}}<span *ngIf="c.lastfile"> — {{c.lastfile}}</span>
											</span>
										</div>
									</div>
								</span>
							</span>
						</div>
					</mat-card-title>
				</mat-card-header>

				<mat-card-content class="mat-card-body" [class.no-scroll]="!c.focused" [ngClass]="{'pl-3 pr-3':c.focused}">
					<ng-container *ngIf="!c.focused" @fade>
						<div class="client-summary">
							<div class="orders-overview" (click)="flipClientCard(c, 'orders')" [ngClass]="openOrdersCount(c) == 0 ? 'no-orders' : 'has-orders'">
								<div class="overview-tile open-orders-tile">
									<span class="overview-value" [ngClass]="openOrdersCount(c) ? 'ordercount-bg':''">{{ openOrdersLoading[c.vendor_key] ? '…' : openOrdersCount(c) }}</span>
									<span class="overview-label">Open Orders</span>
								</div>
								<div class="overview-tile">
									<span class="overview-value-row">
										<span class="overview-value">{{ orderCountsLoading[c.vendor_key] ? '…' : this.overall_counts[c.vendor_key]?.units ?? 0  }}</span>
									</span>
									<span class="overview-label">Units</span>
								</div>
								<i class="material-icons overview-drill-icon" [ngClass]="openOrdersCount(c) ? 'chevron-active':''">chevron_right</i>
							</div>
							<div class="exclusions-summary">
								<div class="summary-row">
									<span class="summary-label" [class.copying]="c.copying" (click)="c.copying ? stopcopy(c): copyfrom(c)">
										<mat-icon class="icon-small" *ngIf="!c.copying && !copying">content_copy</mat-icon>
										<ng-container *ngIf="c.copying">COPYING</ng-container>
										
										<ng-container *ngIf="!c.copying && copying">
											<button mat-stroked-button color="primary" class="btn-small copyto-btn" (click)="copyto(c)">Paste Exclusions</button>
										</ng-container>
										
										<ng-container *ngIf="c.copying || !copying">
											Exclusions
										</ng-container>
									</span>
									<span class="summary-value">{{c.excluded_brands.length}} brands, {{c.excluded_stockids.length}} SKUs</span>
								</div>
							</div>
						</div>
					</ng-container>

					<ng-container *ngIf="c.focused && c.viewing == 'settings'" @fade>
						<div class="settings-panel" [class.mode-api]="c.connection_type === 'api'" [class.mode-ftp]="c.connection_type !== 'api'">

							<div class="settings-section identity-section" *ngIf="c?.adding">
								<div class="settings-section-head"><span class="settings-eyebrow">New Client</span></div>
								<div class="settings-section-body identity-fields">
									<mat-form-field appearance="outline">
										<mat-label>Vendor Key</mat-label>
										<mat-error *ngIf="key_in_use">Client key already being used</mat-error>
										<input matInput [(ngModel)]="c.vendor_key" autocomplete="off" required (input)="keyCheck($event)">
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Vendor Label</mat-label>
										<mat-error *ngIf="label_in_use">Client label already being used</mat-error>
										<input matInput [(ngModel)]="c.vendor_label" autocomplete="off" required (input)="labelCheck($event)">
									</mat-form-field>
								</div>
							</div>

							<div class="settings-section mode-section">
								<div class="settings-section-head"><span class="settings-eyebrow">Connection Mode</span></div>
								<div class="settings-section-body">
									<div class="mode-switch" role="group">
										<button type="button" class="mode-switch-btn" [class.active]="c.connection_type !== 'api'" (click)="c.connection_type = 'ftp'">
											<mat-icon class="mode-switch-icon">folder</mat-icon> File Drop
										</button>
										<button type="button" class="mode-switch-btn" [class.active]="c.connection_type === 'api'" (click)="c.connection_type = 'api'">
											<mat-icon class="mode-switch-icon">bolt</mat-icon> API Access
										</button>
									</div>
									<p class="mode-switch-hint">{{ c.connection_type === 'api' ? "We're the provider — vendors pull their feed on their own schedule using credentials generated below." : "A feed file is pushed to the vendor's server on a schedule." }}</p>
								</div>
							</div>

							<div class="settings-section">
								<div class="settings-section-head"><span class="settings-eyebrow">Customer Link</span></div>
								<div class="settings-section-body debtor-branch-row row w-100">
									<mat-form-field appearance="outline" [ngClass]="{'col-6 m-0 p-0': c.connection_type === 'api'}">
										<mat-label>Debtor</mat-label>
										<mat-icon matPrefix>search</mat-icon>
										<input matInput
											[(ngModel)]="debtorSearchTerm[c.vendor_key]"
											(input)="debtorSearch($event.target.value, c)"
											[matAutocomplete]="autoDebtor"
											placeholder="Name or account #..."
											required
											autocomplete="off">
										<mat-autocomplete #autoDebtor="matAutocomplete" (optionSelected)="selectDebtor(c, $event.option.value)">
											<mat-option *ngFor="let opt of debtorSearchResults[c.vendor_key]" [value]="opt">
												<b>{{opt.debtorno}}</b> &mdash; {{opt.name}}
											</mat-option>
										</mat-autocomplete>
										<mat-spinner matSuffix [diameter]="18" *ngIf="debtorSearching[c.vendor_key]"></mat-spinner>
										<mat-error *ngIf="!c.debtorno">Debtor is required</mat-error>
									</mat-form-field>

									<mat-form-field appearance="outline" [ngClass]="{'col-6 m-0 p-0': c.connection_type === 'api'}">
										<mat-label>Branch</mat-label>
										<mat-select [(ngModel)]="c.branchcode" (selectionChange)="onBranchSelected(c, $event.value)" [disabled]="!c.debtorno" required>
											<mat-option [value]="'all'">All</mat-option>
											<mat-option *ngFor="let b of branchOptions[c.vendor_key]" [value]="b.branchcode">{{b.branchcode}} &mdash; {{b.brname}}</mat-option>
										</mat-select>
										<mat-error *ngIf="!c.branchcode">Branch is required</mat-error>
									</mat-form-field>
								</div>
							</div>

							<div class="settings-section" *ngIf="c.connection_type === 'api'">
								<div class="settings-section-head"><span class="settings-eyebrow">Delivery Types &amp; Freight</span></div>
								<div class="settings-section-body">
									<mat-form-field appearance="fill" class="shipvia-select-field w-50">
										<mat-label>Allowed Delivery Types</mat-label>
										<mat-select [(ngModel)]="c.allowed_shipvia" multiple [compareWith]="compareShipvia" (selectionChange)="onShipviaChange(c)">
											<mat-option *ngFor="let s of shipviaOptions" [value]="s.shipper_id">{{s.shippername}}</mat-option>
										</mat-select>
									</mat-form-field>

									<div class="shipvia-freight-row" *ngIf="c.allowed_shipvia.length">
										<div class="shipvia-freight-item" *ngFor="let id of c.allowed_shipvia">
											<span class="shipvia-freight-label">{{getShipperName(id)}}</span>
											<mat-form-field appearance="outline" class="shipvia-freight-input">
												<mat-label>Freight</mat-label>
												<span matPrefix>$&nbsp;</span>
												<input matInput type="number" min="0" step="0.01" [(ngModel)]="c.shipvia_freight[id]">
											</mat-form-field>
											<mat-checkbox class="shipvia-label-checkbox" [(ngModel)]="c.shipvia_requires_label[id]">Requires shipping label</mat-checkbox>
										</div>
									</div>
								</div>
							</div>

							<div class="settings-section" *ngIf="c.connection_type !== 'api'">
								<div class="settings-section-head"><span class="settings-eyebrow">File Drop Credentials</span></div>
								<div class="settings-section-body ftp-fields-grid">
									<mat-form-field appearance="outline">
										<mat-label>Username</mat-label>
										<input matInput [(ngModel)]="c.username" autocomplete="off">
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Server host</mat-label>
										<input matInput [(ngModel)]="c.serverhost" autocomplete="off">
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>{{ c.password_set ? 'Password (leave blank to keep current)' : 'Password' }}</mat-label>
										<input matInput type="password" [(ngModel)]="c.password" autocomplete="new-password">
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Path</mat-label>
										<input matInput [(ngModel)]="c.path" autocomplete="off">
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Protocol</mat-label>
										<mat-select [(ngModel)]="c.protocol">
											<mat-option value="SFTP">SFTP</mat-option>
											<mat-option value="FTP">FTP</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Protocol Type</mat-label>
										<mat-select [(ngModel)]="c.protocol_type">
											<mat-option value="">Default</mat-option>
											<mat-option value="2">2</mat-option>
											<mat-option value="3">3</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Port</mat-label>
										<input matInput type="number" [(ngModel)]="c.port" autocomplete="off">
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Filename</mat-label>
										<input matInput [(ngModel)]="c.filename" autocomplete="off">
									</mat-form-field>
									<div class="credentials-checkbox-row">
										<mat-checkbox [(ngModel)]="c.emailcopy">Email Copy</mat-checkbox>
										<mat-checkbox [(ngModel)]="c.blankstartrow">Blank Start Row</mat-checkbox>
									</div>
								</div>
							</div>

							<div class="settings-section" *ngIf="c.connection_type === 'api'">
								<div class="settings-section-head"><span class="settings-eyebrow">API Credentials &amp; Endpoints</span></div>
								<div class="settings-section-body api-body-grid">
									<div class="api-main-col">
										<p class="api-provider-note">We're the provider here — vendors connect to us using credentials we generate below. Nothing to send; they'll pull their feed on their own schedule.</p>

										<div class="api-info-group row ml-0 mr-0 w-100">
											<mat-form-field appearance="outline" class="col-5">
												<mat-label>Auth Type</mat-label>
												<mat-select [(ngModel)]="c.auth_type">
													<mat-option value="oauth2_client_credentials">OAuth2 (Client Credentials)</mat-option>
												</mat-select>
											</mat-form-field>

											<ng-container *ngIf="c.auth_type !== 'static_bearer'">
												<mat-form-field appearance="outline" class="col-5">
													<mat-label>Client ID</mat-label>
													<input matInput [ngModel]="c.client_id" disabled placeholder="Not generated yet">
												</mat-form-field>
											</ng-container>
										</div>

										<div class="credentials-generate-row">
											<button mat-stroked-button color="primary" (click)="generateCredentials(c)" [disabled]="c.generatingCredentials">
												{{ c.generatingCredentials ? 'Generating...' : ((c.auth_type === 'static_bearer' ? c.access_token_set : c.client_secret_set) ? 'Rotate Credentials' : 'Generate Credentials') }}
											</button>
											<span class="api-rotate-warning" *ngIf="c.auth_type === 'static_bearer' ? c.access_token_set : c.client_secret_set">Rotating invalidates the vendor's current credential immediately.</span>
										</div>
										

										<div class="api-revealed-credential" *ngIf="c.revealed">
											<p class="api-revealed-title">Copy this now — it won't be shown again:</p>
											<ng-container *ngIf="c.auth_type === 'static_bearer'">
												<code>{{c.revealed.bearer_token}}</code>
											</ng-container>
											<ng-container *ngIf="c.auth_type !== 'static_bearer'">
												<div><strong>Client ID:</strong> <code>{{c.revealed.client_id}}</code></div>
												<div><strong>Client Secret:</strong> <code>{{c.revealed.client_secret}}</code></div>
											</ng-container>
											<button mat-button (click)="dismissRevealedCredentials(c)">Done, I've copied this</button>
										</div>

										<div class="api-endpoints-info pt-4">
											<div class="summary-row" *ngIf="c.auth_type !== 'static_bearer'">
												<span class="summary-label">Token URL</span>
												<span class="summary-value">{{stickerFeedTokenEndpoint}}</span>
											</div>
											<div class="summary-row">
												<span class="summary-label">Feed URL</span>
												<span class="summary-value">{{stickerFeedFeedEndpoint}}</span>
											</div>
										</div>
									</div>


									<div class="api-endpoints-col">
										<span class="settings-eyebrow">Allowed Endpoints</span>
										<div class="api-endpoint-row" *ngFor="let endpoint of c.api_endpoints">
											<span class="summary-label">{{endpoint['function']}}</span>
											<mat-checkbox [checked]="c.allowed_endpoints.includes(endpoint.function_id)" (change)="toggleEndpoint(c, endpoint.function_id)"></mat-checkbox>
										</div>
									</div>
								</div>
							</div>

						<div class="exclusions-row">
						<div class="add-brand-row stockid-section exclusion-col" [class.full-width]="c.showBrandEditor">
							<div class="stockid-toolbar">
								<h5 class="stockid-title">Brand Exclusions <span class="stockid-count">({{c.excluded_brands.length}})</span></h5>
								<button type="button" class="brand-bulk-btn" (click)="toggleBrandEditor(c)">
									<i class="material-icons stockid-btn-icon">{{ c.showBrandEditor ? 'close' : 'edit' }}</i> {{ c.showBrandEditor ? 'Close' : 'Edit Brands' }}
								</button>
							</div>

							<ng-container *ngIf="!c.showBrandEditor">
								<div class="stockid-table-wrap" *ngIf="c.excluded_brands.length">
									<table class="table table-hover table-sm stockid-table">
										<colgroup>
											<col class="col-stockid">
											<col class="col-stockdesc">
											<col class="col-stockremove">
										</colgroup>
										<thead>
											<tr>
												<th>Brand</th>
												<th>Mfg Code</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let brandName of c.excluded_brands">
												<td>{{brandName}}</td>
												<td class="stockid-desc-col">{{ getBrandMfgCode(brandName) }}</td>
												<td class="stockid-remove-col">
													<i class="material-icons stockid-remove-icon" (click)="removeBrand(c, brandName)" title="Remove">close</i>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<p class="stockid-empty-msg" *ngIf="!c.excluded_brands.length">No brands excluded.</p>
							</ng-container>

							<div class="brand-table-row" *ngIf="c.showBrandEditor">
								<div class="brand-toolbar">
									<div class="brand-search-wrap">
										<i class="material-icons brand-search-icon">search</i>
										<input type="text" class="brand-search-input" placeholder="Filter brands…" [(ngModel)]="c.brandFilter" autocomplete="off">
									</div>
									<div class="brand-bulk-actions">
										<button type="button" class="brand-bulk-btn" (click)="setAllBrands(c, true)">Exclude All</button>
										<button type="button" class="brand-bulk-btn" (click)="setAllBrands(c, false)">Allow All</button>
									</div>
								</div>
								<div class="brand-table-wrap">
									<table class="table table-hover table-sm brand-table">
										<colgroup>
											<col class="col-status">
											<col class="col-brand">
											<col class="col-mfgcode">
										</colgroup>
										<thead>
											<tr>
												<th class="brand-status-col"></th>
												<th>Brand</th>
												<th>Mfg Code</th>
											</tr>
										</thead>
										<tbody>
											<ng-container *ngIf="filterBrands(c) as filtered">
												<tr *ngFor="let b of filtered" class="brand-row"
													[class.is-excluded]="c.excluded_brands.includes(b.name)"
													(click)="toggleBrand(c, b.name)">
													<td class="brand-status-col">
														<i class="material-icons brand-status-icon" [ngClass]="c.excluded_brands.includes(b.name) ? 'is-blocked' : 'is-allowed'">
															{{ c.excluded_brands.includes(b.name) ? 'block' : 'check_circle' }}
														</i>
													</td>
													<td class="brand-name-col" [title]="b.name">{{b.name}}</td>
													<td class="brand-mfgcode-col" [title]="b.mfg_code">{{b.mfg_code}}</td>
												</tr>
												<tr *ngIf="!filtered.length">
													<td colspan="3" class="brand-empty-row">No brands match "{{c.brandFilter}}"</td>
												</tr>
											</ng-container>
										</tbody>
									</table>
								</div>
							</div>
						</div>

						<div class="add-brand-row stockid-section exclusion-col" [class.full-width]="c.showItemPicker">
							<div class="stockid-toolbar">
								<h5 class="stockid-title">Stock ID Exclusions <span class="stockid-count">({{c.excluded_stockids.length}})</span></h5>
								<div class="stockid-actions">
									<button type="button" class="brand-bulk-btn" (click)="toggleItemPicker(c)">
										<i class="material-icons stockid-btn-icon">search</i> {{ c.showItemPicker ? 'Close Search' : 'Search & Add' }}
									</button>
									<button type="button" class="brand-bulk-btn" (click)="stockidFileInput.click()">
										<i class="material-icons stockid-btn-icon">upload_file</i> Upload Excel
									</button>
									<input #stockidFileInput type="file" accept=".xlsx,.xls,.csv" hidden (change)="onStockIdFileSelect($event, c)">
								</div>
							</div>

							<p class="stockid-upload-error" *ngIf="stockidUploadError[c.vendor_key]">{{stockidUploadError[c.vendor_key]}}</p>

							<div class="item-picker-panel" *ngIf="c.showItemPicker">
								<app-item-picker [selectionReverse]="true" [currentItems]="c.excluded_stockids" (saveresults)="updateBlockedSkus(c, $event)"></app-item-picker>
							</div>

							<ng-container *ngIf="!c.showItemPicker">
								<div class="stockid-table-wrap" *ngIf="c.excluded_stockids.length">
									<table class="table table-hover table-sm stockid-table">
										<colgroup>
											<col class="col-stockid">
											<col class="col-stockdesc">
											<col class="col-stockremove">
										</colgroup>
										<thead>
											<tr>
												<th>Stock ID</th>
												<th>Description</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let item of c.excluded_stockids">
												<td>{{item.stockid}}</td>
												<td class="stockid-desc-col" [title]="item.description">{{item.description}}</td>
												<td class="stockid-remove-col">
													<i class="material-icons stockid-remove-icon" (click)="removeStockId(c, item.stockid)" title="Remove">close</i>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<p class="stockid-empty-msg" *ngIf="!c.excluded_stockids.length">No stock IDs excluded.</p>
							</ng-container>
						</div>
						</div>
							<div class="settings-footer">
								<button mat-stroked-button class="btn-danger" [matTooltip]="'Permanently remove client access and entry'" (click)="removeclient(c)">Delete Client</button>
								<div class="settings-footer-spacer"></div>
								<button mat-stroked-button *ngIf="c.connection_type !== 'api'" [matTooltip]="'One time sending of feed'" (click)="run(c)">Generate &amp; Send Feed?</button>
								<span class="saved-msg" *ngIf="saved[c.vendor_key]">Saved</span>
								<span class="save-error-msg" *ngIf="saveError[c.vendor_key]">{{saveError[c.vendor_key]}}</span>
								<button mat-stroked-button color="primary" (click)="save(c)" [disabled]="saving[c.vendor_key] || c.vendor_key == '' || c.vendor_label == '' || !c.debtorno || !c.branchcode"> {{ saving[c.vendor_key] ? 'Saving...' : 'Save Client' }} </button>
							</div>
						</div>
					</ng-container>

					<ng-container *ngIf="c.focused && c.viewing == 'analytics'" @fade>
						<div class="logs-toolbar">
							<mat-form-field appearance="outline" class="logs-date-field">
								<mat-label>From</mat-label>
								<input matInput type="date" [(ngModel)]="logsDateFrom[c.vendor_key]">
							</mat-form-field>
							<mat-form-field appearance="outline" class="logs-date-field">
								<mat-label>To</mat-label>
								<input matInput type="date" [(ngModel)]="logsDateTo[c.vendor_key]">
							</mat-form-field>
							<button mat-stroked-button color="primary" (click)="searchLogs(c)" [disabled]="logsLoading[c.vendor_key]">Search</button>
						</div>

						<p class="save-error-msg" *ngIf="logsError[c.vendor_key]">{{logsError[c.vendor_key]}}</p>

						<div class="logs-loading" *ngIf="logsLoading[c.vendor_key]">Loading...</div>

						<ng-container *ngIf="!logsLoading[c.vendor_key]">
							<div class="stockid-table-wrap log-table-wrap" *ngIf="(logs[c.vendor_key] || []).length; else noLogs">
								<table class="table table-hover table-sm stockid-table log-table">
									<thead>
										<tr>
											<th class="col-2">Time</th>
											<th class="col-2">Action</th>
											<th class="text-center col-1">Result</th>
											<th class="text-center col-1">Status</th>
											<th class="col-6">Detail</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let log of logs[c.vendor_key]">
											<td >{{formatLogTimestamp(log.created_at)}}</td>
											<td>{{log.action}}</td>
											<td [ngClass]="{'log-result-success text-center': log.result === 'success', 'text-center log-result-fail': log.result === 'fail'}">
												<div>{{log.result | uppercase}}</div>
											</td>
											<td class="text-center">{{log.http_status}}</td>
											<td  [title]="log.error_detail">{{log.error_detail}}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<ng-template #noLogs>
								<p class="stockid-empty-msg">No log entries found{{ logsDateFrom[c.vendor_key] || logsDateTo[c.vendor_key] ? ' for this date range' : '' }}.</p>
							</ng-template>
						</ng-container>

						<div class="logs-pager" *ngIf="(logsTotal[c.vendor_key] || 0) > 0">
							<button mat-button (click)="logsPrevPage(c)" [disabled]="(logsPage[c.vendor_key] || 1) <= 1 || logsLoading[c.vendor_key]">Previous</button>
							<span class="logs-pager-label">Page {{logsPage[c.vendor_key] || 1}} of {{logsTotalPages(c)}} &nbsp;({{logsTotal[c.vendor_key]}} entries)</span>
							<button mat-button (click)="logsNextPage(c)" [disabled]="(logsPage[c.vendor_key] || 1) >= logsTotalPages(c) || logsLoading[c.vendor_key]">Next</button>
						</div>
					</ng-container>

					<ng-container *ngIf="c.focused && c.viewing == 'orders'" @fade>
						<div class="orders-view-toolbar">
							<div class="order-period-toggle">
								<div class="mode-switch" role="group">
									<button type="button" class="mode-switch-btn" [class.active]="historicalView !== true" (click)="historicalView = false">
										<mat-icon class="mode-switch-icon">folder</mat-icon> Open
									</button>
									<button type="button" class="mode-switch-btn" [class.active]="historicalView === true" (click)="switchToHistorical(c)">
										<mat-icon class="mode-switch-icon">history</mat-icon> Historical
									</button>
								</div>
								<button type="button" class="period-btn toggle" (click)="showgraph()"><mat-icon>visibility</mat-icon></button>
								<button type="button" class="period-btn" [ngClass]="{'graph-visible': graph_visible, 'graph-hidden': !graph_visible}" [class.active]="orderPeriod[c.vendor_key] === 'week'" (click)="setOrderPeriod(c, 'week')">Week</button>
								<button type="button" class="period-btn" [ngClass]="{'graph-visible': graph_visible, 'graph-hidden': !graph_visible}" [class.active]="(orderPeriod[c.vendor_key] || 'mtd') === 'mtd'" (click)="setOrderPeriod(c, 'mtd')">MTD</button>
								<button type="button" class="period-btn" [ngClass]="{'graph-visible': graph_visible, 'graph-hidden': !graph_visible}" [class.active]="orderPeriod[c.vendor_key] === 'custom'" (click)="setOrderPeriod(c, 'custom')">Custom</button>
							</div>
							<div class="custom-range-picker" *ngIf="orderPeriod[c.vendor_key] === 'custom'" [ngClass]="{'graph-visible': graph_visible, 'graph-hidden': !graph_visible}">
								<mat-form-field appearance="outline" class="logs-date-field">
									<mat-label>From</mat-label>
									<input matInput type="date" [(ngModel)]="customDateFrom[c.vendor_key]" [ngModelOptions]="{standalone: true}">
								</mat-form-field>
								<mat-form-field appearance="outline" class="logs-date-field">
									<mat-label>To</mat-label>
									<input matInput type="date" [(ngModel)]="customDateTo[c.vendor_key]" [ngModelOptions]="{standalone: true}">
								</mat-form-field>
								<button mat-stroked-button color="primary" (click)="applyCustomRange(c)" [disabled]="!customDateFrom[c.vendor_key] || !customDateTo[c.vendor_key]">Apply</button>
							</div>
							<div class="orders-search">
								<mat-icon class="orders-search-icon">search</mat-icon>
								<mat-chip-list class="orders-search-chips" aria-label="Active filters"
									*ngIf="(searchChips[c.vendor_key] || []).length || chartDateFilter[c.vendor_key]">
									<mat-chip *ngIf="chartDateFilter[c.vendor_key]" [removable]="true"
										(removed)="clearChartDateFilter(c)" class="active-filter-chip">
										<span class="active-filter-chip__label">Date</span>
										<span class="active-filter-chip__sep">:</span>
										<span class="active-filter-chip__value">{{ chartDateFilter[c.vendor_key] }}</span>
										<mat-icon matChipRemove>cancel</mat-icon>
									</mat-chip>
									<mat-chip *ngFor="let term of searchChips[c.vendor_key]" [removable]="true"
										(removed)="removeSearchChip(c, term)" class="active-filter-chip">
										<span class="active-filter-chip__value">{{ term }}</span>
										<mat-icon matChipRemove>cancel</mat-icon>
									</mat-chip>
								</mat-chip-list>
								<input type="text" class="orders-search-input"
									placeholder="Search order #, cust ref #, tracking #, document #, or stock ID — press Enter"
									[(ngModel)]="ordersSearchTerm[c.vendor_key]" [ngModelOptions]="{standalone: true}"
									(keydown.enter)="commitSearchChip(c)">
								<i class="material-icons orders-search-clear" *ngIf="ordersSearchTerm[c.vendor_key]"
									(click)="ordersSearchTerm[c.vendor_key] = ''">close</i>
							</div>
							<span class="orders-view-total">
								<ng-container *ngIf="historicalView ? historicalOrdersLoading[c.vendor_key] : openOrdersLoading[c.vendor_key]">Loading…</ng-container>
								<ng-container *ngIf="!(historicalView ? historicalOrdersLoading[c.vendor_key] : openOrdersLoading[c.vendor_key])">{{ reportOrdersCount(c) }} orders &middot; {{ reportUnitsCount(c) }} units</ng-container>
							</span>
						</div>

						<div class="activity-trend-chart-wrap" [ngClass]="{'graph-visible': graph_visible, 'graph-hidden': !graph_visible}">
							<div class="logs-loading" *ngIf="activityTrendLoading[c.vendor_key]">Loading trend…</div>
							<canvas #activityChartRef [attr.data-key]="c.vendor_key" class="activity-trend-chart" [ngClass]="{'graph-visible': graph_visible, 'graph-hidden': !graph_visible}"></canvas>
							<div class="chart-point-popover" *ngIf="chartPopover[c.vendor_key] as pop"
								[style.left.px]="pop.x" [style.top.px]="pop.y">
								<button type="button" class="chart-point-popover-close" (click)="chartPopover[c.vendor_key] = null">&times;</button>
								<div class="chart-point-popover-date">{{ pop.date }}</div>
								<div class="chart-point-popover-counts">{{ pop.orders }} orders &middot; {{ pop.logs }} log events</div>
								<ng-container *ngIf="!historicalView">
									<div class="chart-point-popover-orders" *ngIf="pop.orderNumbers.length">
										<span *ngFor="let o of pop.orderNumbers">{{ o }}</span>
									</div>
									<div class="chart-point-popover-empty" *ngIf="!pop.orderNumbers.length">No matching open orders.</div>
								</ng-container>
								<div class="chart-point-popover-hint" *ngIf="historicalView">See filtered list below for order details.</div>
							</div>
						</div>

						<div class="graph-orders-report" *ngIf="historicalView">
							<div class="order-detail-panel historical" *ngIf="selectedHistoricalOrder[c.vendor_key] as histsel">
								<button mat-icon-button color="accent" class="pos-upper-right" (click)="selectHistoricalOrder(histsel, c.vendor_key)"><mat-icon>cancel</mat-icon></button>
								<strong class="order-detail-label-head" [class]="'status-' + histsel.orderstatusid">HISTORICAL ORDER DETAILS</strong>
								<div class="order-detail-header">
									<div class="order-detail-header-row">
										<span class="order-detail-label">Order #</span>
										<span class="order-detail-value"><b>{{histsel.orderno}}</b></span>
										<span class="order-detail-label">Status</span>
										<span class="order-detail-value">
											<span class="order-status-pill" [class]="'status-' + histsel.orderstatusid">{{histsel.status || '-'}}</span>
										</span>
										<span class="order-detail-label packed"><mat-icon>inventory_2</mat-icon>Packed</span>
										<span class="order-detail-value">
											<ng-container *ngIf="histsel.packedtime != '' && !!histsel.packedtime;else empty">{{histsel.packedtime | date:'M/d/Y h:m a'}} &nbsp;&rightarrow;</ng-container>
											<ng-template #empty>-</ng-template>
											<strong>{{histsel.packeduserid}}</strong>
										</span>
									</div>
									<div class="order-detail-header-row">
										<span class="order-detail-label">Debtor</span>
										<span class="order-detail-value">{{histsel.debtorno}}</span>
										<span class="order-detail-label">Branch</span>
										<span class="order-detail-value">{{histsel.branchcode}}</span>
										<span class="order-detail-label staged"><mat-icon>done</mat-icon>Staged</span>
										<span class="order-detail-value">
											<ng-container *ngIf="histsel.stagedtime != '' && !!histsel.stagedtime; else empty">{{histsel.stagedtime | date:'M/d/Y h:m a'}}&nbsp;&rightarrow;</ng-container>
											<ng-template #empty>-</ng-template>
											<strong>{{histsel.stageduserid}}</strong>
										</span>
									</div>
									<div class="order-detail-header-row" *ngIf="shipToLines(histsel).length">
										<span class="order-detail-label">Ship To</span>
										<span class="order-detail-value order-detail-address">
											<ng-container *ngFor="let line of shipToLines(histsel); let last = last">{{line}}<span *ngIf="!last">, </span></ng-container>
										</span>
										<span class="order-detail-label">Comments</span>
										<span class="order-detail-value">
											<ng-container *ngIf="histsel.comments != '';else histEmpty">{{histsel.comments}}</ng-container>
											<ng-template #histEmpty>-</ng-template>
										</span>
										<span class="order-detail-label shipped"><mat-icon>local_shipping</mat-icon>Shipped</span>
										<span class="order-detail-value">
											<ng-container *ngIf="histsel.shippedtime != '' && !!histsel.shippedtime;else empty"> {{histsel.shippedtime | date:'M/d/Y h:m a'}}</ng-container>
											<ng-template #empty>-</ng-template>
										</span>
									</div>
								</div>

								<div class="logs-loading" *ngIf="orderLinesLoading[histsel.orderno]">Loading…</div>
								<strong>ORDER LINES</strong>
								<div class="order-detail-columns" *ngIf="!orderLinesLoading[histsel.orderno]">
									<div class="order-detail-col">
										<div class="stockid-table-wrap">
											<table class="order-line-table table-bordered order-line-table-lg" *ngIf="selectedHistoricalOrderLines(c.vendor_key).length; else noHistItemsExpanded">
												<thead>
													<tr class="dark-head"><th>Stock ID</th><th>Description</th><th class="text-center">Qty</th><th>Price</th></tr>
												</thead>
												<tbody>
													<tr *ngFor="let item of selectedHistoricalOrderLines(c.vendor_key)">
														<td><strong>{{item.stockid}}</strong></td>
														<td class="stockid-desc-col"><strong>{{item.description}}</strong></td>
														<td class="text-center"><strong>{{item.ordered}}</strong></td>
														<td><strong>{{item.unitprice | currency}}</strong></td>
													</tr>
												</tbody>
											</table>
											<ng-template #noHistItemsExpanded>
												<p class="stockid-empty-msg">No item detail.</p>
											</ng-template>
										</div>

										<div class="order-totals">
											<div class="logs-loading" *ngIf="orderTotalsLoading[histsel.orderno]">Loading totals…</div>
											<ng-container *ngIf="histsel.total_amount">
												<div class="order-totals-row invoice-view" (click)="openDocument(histsel,details, 'pdf')"><mat-icon>visibility</mat-icon><span>Invoice Total</span><span>{{histsel.total_amount | currency}}</span></div>
											</ng-container>
										</div>
									</div>
								</div>
							</div>
							<h5 class="stockid-title mt-3">Historical Orders - capped to 500 latest sticker orders <span class="stockid-count">({{ historicalOrdersTotal[c.vendor_key] || 0 }})</span></h5>
							<div class="logs-loading" *ngIf="historicalOrdersLoading[c.vendor_key]">Loading...</div>
							<ng-container *ngIf="!historicalOrdersLoading[c.vendor_key]">
								<div class="stockid-table-wrap orders-list-table-wrap" *ngIf="(historicalOrders[c.vendor_key] || []).length; else noHistoricalOrdersExpanded">
									<table class="table table-hover table-sm stockid-table">
										<thead>
											<tr>
												<th></th>
												<th>Order #</th>
												<th>Cust Ref</th>
												<th>Order Date</th>
												<th class="tracking-col">Tracking #</th>
												<th>Document #</th>
												<th>Status</th>
												<th>Invoice Date</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let ord of historicalOrders[c.vendor_key]"
												class="order-row"
												[class.is-selected]="isHistoricalOrderSelected(ord, c.vendor_key)"
												(click)="selectHistoricalOrder(ord, c.vendor_key)">
												<td class="goto-cell">
													<i class="material-icons goto-order-btn" title="Go to order" (click)="goToOrder(ord.orderno, $event)">open_in_new</i>
												</td>
												<td><b>{{ord.orderno}}</b></td>
												<td>{{ord.ponumber}}</td>
												<td>{{formatOrderDateCreated(ord.date_created)}}</td>
												<td class="tracking-col">
													<span class="tracking-list" *ngIf="ord.tracking && ord.tracking.length; else noTrackingExpanded">
														<span *ngFor="let track of ord.tracking" class="tracking-pill" [ngClass]="getTrackingColor(track.shippername)">
															{{track.shippername}}:&nbsp;{{track.trackingnumber}}
															<span class="order-bound-indicator" *ngIf="track.bind == 1">BINDED</span>
														</span>
													</span>
													<ng-template #noTrackingExpanded>—</ng-template>
												</td>
												<td><b>{{ord.transno}}</b></td>
												<td>{{ord.transno ? 'INVOICED' : (ord.status ?? '-')}}</td>
												<td>{{formatOrderDateCreated(ord.inputdate)}}</td>
											</tr>
										</tbody>
									</table>
									<mat-paginator
										[length]="historicalOrdersTotal[c.vendor_key] || 0"
										[pageIndex]="historicalOrdersPageIndex[c.vendor_key] || 0"
										[pageSize]="historicalOrdersPageSize[c.vendor_key] || 25"
										[pageSizeOptions]="[10, 25, 50, 100]"
										showFirstLastButtons
										(page)="onHistoricalPage(c, $event)">
									</mat-paginator>
								</div>
								<ng-template #noHistoricalOrdersExpanded>
									<p class="stockid-empty-msg">{{ (searchChips[c.vendor_key] || []).length || chartDateFilter[c.vendor_key] ? 'No historical orders match your search.' : 'No historical orders to show.' }}</p>
								</ng-template>
							</ng-container>
						</div>

						<ng-container *ngIf="!historicalView">

							<div class="order-detail-panel" *ngIf="selectedOrder[c.vendor_key] as sel">
								<button mat-icon-button color="accent" class="pos-upper-right" (click)="selectOrder(sel, c.vendor_key)"><mat-icon>cancel</mat-icon></button>
								<strong class="order-detail-label-head" [class]="'status-' + sel.orderstatusid">OPEN ORDER DETAILS</strong>
								<div class="order-detail-header">
									<div class="order-detail-header-row">
										<span class="order-detail-label">Order #</span>
										<span class="order-detail-value"><b>{{sel.orderno}}</b></span>
										<span class="order-detail-label">Status</span>
										<span class="order-detail-value">
											<span class="order-status-pill" [class]="'status-' + sel.orderstatusid">{{sel.status}}</span>
										</span>
										<span class="order-detail-label packed"><mat-icon>inventory_2</mat-icon>Packed</span>
										<span class="order-detail-value">
											<ng-container *ngIf="sel.stickerdetails.packedtime != '' && !!sel.stickerdetails.packedtime;else empty">{{sel.stickerdetails.packedtime | date:'M/d/Y h:m a'}} &nbsp;&rightarrow;</ng-container>
											<ng-template #empty>-</ng-template>
											<strong>{{sel.stickerdetails.packeduserid}}</strong>
										</span>
									</div>
									<div class="order-detail-header-row">
										<span class="order-detail-label">Debtor</span>
										<span class="order-detail-value">{{sel.debtorno}}</span>
										<span class="order-detail-label">Branch</span>
										<span class="order-detail-value">{{sel.branchcode}}</span>
										<span class="order-detail-label staged"><mat-icon>done</mat-icon>Staged</span>
										<span class="order-detail-value">
											<ng-container *ngIf="sel.stickerdetails.stagedtime != '' && !!sel.stickerdetails.stagedtime; else empty">{{sel.stickerdetails.stagedtime | date:'M/d/Y h:m a'}}&nbsp;&rightarrow;</ng-container>
											<ng-template #empty>-</ng-template>
											<strong>{{sel.stickerdetails.stageduserid}}</strong>
										</span>
									</div>
									<div class="order-detail-header-row" *ngIf="shipToLines(sel).length">
										<span class="order-detail-label">Ship To</span>
										<span class="order-detail-value order-detail-address">
											<ng-container *ngFor="let line of shipToLines(sel); let last = last">{{line}}<span *ngIf="!last">, </span></ng-container>
										</span>
										<span class="order-detail-label">Comments</span>
										<span class="order-detail-value">
											<ng-container *ngIf="sel.comments != '';else empty">{{sel.comments}}</ng-container>
											<ng-template #empty>-</ng-template>
										</span>
										<span class="order-detail-label shipped"><mat-icon>local_shipping</mat-icon>Shipped</span>
										<span class="order-detail-value">
											<ng-container *ngIf="sel.stickerdetails.shippedtime != '' && !!sel.stickerdetails.shippedtime;else empty"> {{sel.stickerdetails.shippedtime | date:'M/d/Y h:m a'}}</ng-container>
											<ng-template #empty>-</ng-template>
										</span>
									</div>
								</div>

								<div class="logs-loading" *ngIf="orderLinesLoading[sel.orderno]">Loading…</div>
								<strong>ORDER LINES</strong>
								<div class="order-detail-columns" *ngIf="!orderLinesLoading[sel.orderno]">
									<div class="order-detail-col">
										<div class="stockid-table-wrap">
											<table class="order-line-table table-bordered order-line-table-lg" *ngIf="selectedOrderLines(c.vendor_key).length; else noItemsExpanded">
												<thead>
													<tr class="dark-head"><th>Stock ID</th><th>Description</th><th class="text-center">Qty</th><th>Price</th></tr>
												</thead>
												<tbody>
													<tr *ngFor="let item of selectedOrderLines(c.vendor_key)">
														<td><strong>{{item.stockid}}</strong></td>
														<td class="stockid-desc-col">{{item.description}}</td>
														<td class="text-center">{{item.ordered}}</td>
														<td>{{item.unitprice | currency}}</td>
													</tr>
												</tbody>
											</table>
											<ng-template #noItemsExpanded>
												<p class="stockid-empty-msg">No item detail.</p>
											</ng-template>
										</div>

										<div class="order-totals">
											<div class="logs-loading" *ngIf="orderTotalsLoading[sel.orderno]">Loading totals…</div>
											<ng-container *ngIf="!orderTotalsLoading[sel.orderno] && orderTotals[sel.orderno] as totals">
												<div class="order-totals-row"><span>Subtotal</span><span>{{totals.subtotal | currency}}</span></div>
												<div class="order-totals-row"><span>Freight</span><span>{{totals.freighttotal | currency}}</span></div>
												<div class="order-totals-row"><span>Tax</span><span>{{totals.taxtotal | currency}}</span></div>
												<div class="order-totals-row order-totals-grand"><span>Sales Order Total</span><span>{{totals.total | currency}}</span></div>
											</ng-container>
										</div>
									</div>

									<div class="order-detail-col" *ngIf="hasAnyPoForItems({ vendorKey: c.vendor_key, orderno: sel.orderno, items: selectedOrderLines(c.vendor_key) })">
										<div class="stockid-table-wrap">
											<table class="order-line-table order-line-table-lg table-bordered">
												<thead>
													<tr class="dark-head">
														<th>PO #</th>
														<th class="text-center">Supplier</th>
														<th>Ordered On</th>
														<th>Requisition #</th>
														<th class="text-center">Qty Ord</th>
														<th class="text-center">Qty Recd</th>
														<th>Price</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let item of selectedOrderLines(c.vendor_key)">
														<ng-container *ngIf="poForOrderLine(c.vendor_key, sel.orderno, item.orderlineno) as po; else noPoRowExpanded">
															<td>{{po.ponumber}}</td>
															<td class="text-center">{{po.supplierno}}</td>
															<td>{{formatOrderDateCreated(po.orddate)}}</td>
															<td>{{po.requisitionno || '—'}}</td>
															<td class="text-center">{{po.quantityord}}</td>
															<td class="text-center">{{po.quantityrecd}}</td>
															<td>{{po.unitprice | currency}}</td>
														</ng-container>
														<ng-template #noPoRowExpanded>
															<td colspan="7">—</td>
														</ng-template>
													</tr>
												</tbody>
												<tfoot>
													<tr class="order-line-total-row">
														<td colspan="6">Purchase Order Total</td>
														<td>{{poRowsTotal({ vendorKey: c.vendor_key, orderno: sel.orderno, items: selectedOrderLines(c.vendor_key) }) | currency}}</td>
													</tr>
												</tfoot>
											</table>
										</div>
									</div>

									
								</div>
								<div class="shipping-labels">
									<div class="label-print-all">
										<button mat-flat-button class="btn-small btn-label-print" (click)="printLabels(orderfiles)"><strong>Print All Shipping Labels</strong><mat-icon>print</mat-icon></button>
									</div>
									<mat-grid-list cols="3" rowHeight="1:1" gutterSize="16px" class="labels-row">
										<ng-container *ngIf="!orderfiles || orderfiles.length === 0">
											<div mat-subheader *ngIf="!loadingfiles">No Labels</div>
											<div mat-subheader *ngIf="loadingfiles">
												<mat-spinner matSuffix [diameter]="18"></mat-spinner>
											</div>
										</ng-container>
										<ng-container *ngIf="orderfiles && orderfiles.length > 0">

											<ng-container *ngFor="let f of orderfiles;">
												<mat-grid-tile class="pl-3 pr-3">
													<!-- Image Handling -->
													<div class="row d-flex file-row" *ngIf="isImage(f)">
														<mat-card class="file-card ml-2">
															<img mat-card-image [src]="f.link" (click)="openFile(f)" alt="{{ f.name }}">
															{{ f.name }}
														</mat-card>
														<button mat-icon-button class="mr-2" (click)="removeShippingLabel(f, sel)">
															<mat-icon>delete</mat-icon>
														</button>
													</div>

													<div class="row d-flex file-row nowrap" *ngIf="!isImage(f) && !isVideo(f)">
														<mat-card class="file-card ml-2" >
															<mat-card-content (click)="openFile(f)">
																{{ f.name }}
															</mat-card-content>
														</mat-card>
														<button mat-icon-button class="mr-2 " (click)="removeShippingLabel(f, sel)">
															<mat-icon>delete</mat-icon>
														</button>
													</div>
												</mat-grid-tile>
											</ng-container>
										</ng-container>
									</mat-grid-list>
									<mat-grid-tile class="shipping-label-add">
										<div class="row d-flex">
											<mat-card class="file-card file-add ml-2">
												<mat-card-content>
													<ngx-dropzone [multiple]="false" [disabled]="uploadingShippingLabel" (change)="onSelectShippingLabel($event, sel)" class="dropzone-container" id="shiplabeldropzone">
														<ngx-dropzone-label class="dropzone-label">
															{{ uploadingShippingLabel ? 'UPLOADING...' : 'UPLOAD LABEL' }}
														</ngx-dropzone-label>
													</ngx-dropzone>
												</mat-card-content>
											</mat-card>
										</div>
									</mat-grid-tile>
								</div>
							</div>

							<h5 class="stockid-title mt-3">Open Sales Orders <span class="stockid-count">({{ filteredOpenOrdersCount(c) }})</span></h5>
							<div class="logs-loading" *ngIf="openOrdersLoading[c.vendor_key]">Loading...</div>
							<ng-container *ngIf="!openOrdersLoading[c.vendor_key]">
								<div class="stockid-table-wrap orders-list-table-wrap" *ngIf="filteredOpenOrdersCount(c); else noOpenOrdersExpanded">
									<table class="table table-hover table-sm stockid-table">
										<thead>
											<tr>
												<th></th>
												<th class="text-center">Order #</th>
												<th class="text-center">Status</th>
												<th class="text-center">Cust Ref</th>
												<th class="text-center">Created</th>
												<th class="text-center">Ship Via</th>
												<th class="tracking-col">Tracking #</th>
												<th class="text-center">POs</th>
												<th class="text-center">Deliver To</th>
												<th class="text-center">Delivery Date</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let o of displayedOpenOrders(c)"
												class="order-row"
												[class.is-selected]="isOrderSelected(o, c.vendor_key)"
												(click)="selectOrder(o, c.vendor_key)">
												<td class="goto-cell">
													<i class="material-icons goto-order-btn" title="Go to order" (click)="goToOrder(o.orderno, $event)">open_in_new</i>
												</td>
												<td class="text-center"> <b>{{o.orderno}}</b> </td>
												<td class="text-center">
													<span class="order-status-pill" [class]="'status-' + o.orderstatusid">{{o.status}}</span>
												</td>
												<td class="text-center">{{o.ponumber}}</td>
												<td class="text-center">{{formatOrderDateCreated(o.date_created)}}</td>
												<td class="text-center">{{getShipperName(o.shipvia) || '—'}}</td>
												<td class="tracking-col">
													<span class="tracking-list" *ngIf="o.tracking && o.tracking.length; else noTrackingExpanded">
														<span *ngFor="let track of o.tracking" class="tracking-pill" [ngClass]="getTrackingColor(track.shippername)">
															{{track.shippername}}:&nbsp;{{track.trackingnumber}}
															<span class="order-bound-indicator" *ngIf="track.bind == 1">BINDED</span>
														</span>
													</span>
													<ng-template #noTrackingExpanded>—</ng-template>
												</td>
												<td class="text-center">
													<span class="po-badge" *ngIf="openPOsForOrder(c.vendor_key, o.orderno).length" title="Open purchase orders for this order">
														<i class="material-icons po-badge-icon">inventory_2</i>{{ openPOsForOrder(c.vendor_key, o.orderno).length }}
													</span>
												</td>
												<td class="text-center">{{o.deliverto}}</td>
												<td class="text-center">{{o.deliverydate}}</td>
												<td class="text-color-gray">
													<ng-container *ngIf="isOrderSelected(o, c.vendor_key)">
														<mat-icon class="vert-align">print</mat-icon>&nbsp;
														<button mat-stroked-button (click)="$event.preventDefault(); $event.stopPropagation(); reprint('pick', o)" [matTooltip]="'Print picking slip'">
															Pick Ticket
														</button>
														<button mat-stroked-button (click)="$event.preventDefault(); $event.stopPropagation(); reprint('invoice', o)" [matTooltip]="'Print customer copy'">
															Customer Copy
														</button>
														<button mat-stroked-button  (click)="$event.preventDefault(); $event.stopPropagation(); cancelOrder(o, c)" [matTooltip]="'Cancel order & PO & Remove from container'">
															Cancel Order
														</button>
													</ng-container>
												</td>
											</tr>
										</tbody>
									</table>
									<mat-paginator
										[length]="filteredOpenOrdersCount(c)"
										[pageIndex]="openOrdersPageIndex[c.vendor_key] || 0"
										[pageSize]="openOrdersPageSize[c.vendor_key] || 10"
										[pageSizeOptions]="[10, 25, 50]"
										showFirstLastButtons
										(page)="onOpenOrdersPage(c, $event)">
									</mat-paginator>
								</div>
								<ng-template #noOpenOrdersExpanded>
									<p class="stockid-empty-msg">{{ (searchChips[c.vendor_key] || []).length || chartDateFilter[c.vendor_key] ? 'No open orders match your search.' : 'No open orders.' }}</p>
								</ng-template>

								
							</ng-container>
						</ng-container>
					</ng-container>
				</mat-card-content>

				<mat-card-actions class="mat-card-footer">
					<ng-container *ngIf="!c.focused">
						<svg class="card-icon" width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="analytics_icon" (click)="flipClientCard(c, 'analytics')" title="Connection log"></svg>
						<svg class="card-icon" width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="orders_icon" (click)="flipClientCard(c, 'orders')" title="Orders"></svg>
						<svg class="card-icon" width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" [innerHTML]="settings_icon" (click)="flipClientCard(c, 'settings')" title="Settings"></svg>
					</ng-container>
					<button mat-button *ngIf="c.focused" (click)="closeExpanded()">Close</button>
				</mat-card-actions>
			</mat-card>
		</div>
			</div>
		</div>
	</ng-container>

</div>




<ng-template #documentModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Document {{ viewingdoc.name }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="mb-3 ml-auto mr-auto">
			<app-iframe-view [src]="viewingdoc.link+'?'"></app-iframe-view>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>


<ng-template #confirmCancelSticker let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="modal-title">Confirm Cancellation</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body px-3 pb-3">
		<p>Cancel order <strong>#{{cancellingOrder?.orderno}}</strong>? This will also cancel any linked purchase order and remove its uploaded shipping labels.</p>
		<div class="form-group">
			<label class="font-weight-bold d-block mb-3">Choose a reason for cancellation</label>
			<div class="reason-grid">
				<button type="button" *ngFor="let reason of cancelReasons" class="reason-tile" [class.selected]="selectedCancelReason?.code === reason.code" (click)="selectCancelReason(reason)">
					{{ reason.label }}
				</button>
			</div>
		</div>
		<div class="form-group mt-4" *ngIf="cancelStickerReasonRequiresNotes">
			<label for="cancelStickerNotes" class="font-weight-bold">Additional details</label>
			<textarea id="cancelStickerNotes" class="form-control shadow-sm" placeholder="Please provide more info..." rows="3" [(ngModel)]="cancelNotesText"></textarea>
		</div>
		<div *ngIf="cancelStickerError" class="alert alert-danger mt-3">{{cancelStickerError}}</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Close</button>
		<button class="btn btn-danger" (click)="confirmCancelOrder(modal)" [disabled]="cancellingStickerOrderNo === cancellingOrder?.orderno">
			{{ cancellingStickerOrderNo === cancellingOrder?.orderno ? 'Cancelling...' : 'Confirm Cancellation' }}
		</button>
	</div>
</ng-template>

<ng-template #details let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{ displaydetails.title }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="mb-3" *ngIf="displaydetails">
			<h4></h4>
			<ng-container *ngIf="displaydetails.type == 'html'">
				<div [innerHTML]="displaydetails.display">
				</div>
			</ng-container>
			<ng-container *ngIf="displaydetails.type == 'pdf'">
				<ngx-extended-pdf-viewer [base64Src]="displaydetails.display" useBrowserLocale="true" [handTool]="false" [textLayer]="true" [showOpenFileButton]="false" [showPropertiesButton]="false" [showHandToolButton]="true" [filenameForDownload]="displaydetails.title"></ngx-extended-pdf-viewer>
			</ng-container>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>